/**
 * localStorage helpers for audit performance chart filters
 * (scoped per user + program + optional site scope).
 */

export const AUDIT_PERFORMANCE_FILTER_KEY_PREFIX =
    'audit-performance-filters:';

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {string|null|undefined} siteScope
 * @returns {string}
 */
export function buildAuditPerformanceFilterStorageKey(
    userId,
    programCode,
    siteScope = null
) {
    const programKey =
        programCode && String(programCode).trim()
            ? String(programCode).trim()
            : 'all';
    const baseKey = `${AUDIT_PERFORMANCE_FILTER_KEY_PREFIX}${userId}:${programKey}`;
    const normalizedSiteScope =
        siteScope && String(siteScope).trim() ? String(siteScope).trim() : null;
    return normalizedSiteScope
        ? `${baseKey}:site:${normalizedSiteScope}`
        : baseKey;
}

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {string|null|undefined} siteScope
 * @returns {object|null}
 */
export function loadAuditPerformanceFilterPayload(
    userId,
    programCode,
    siteScope = null
) {
    if (userId == null) return null;
    const key = buildAuditPerformanceFilterStorageKey(
        userId,
        programCode,
        siteScope
    );
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

/**
 * @param {string|number} userId
 * @param {string|null|undefined} programCode
 * @param {object} payload
 * @param {string|null|undefined} siteScope
 */
export function saveAuditPerformanceFilterPayload(
    userId,
    programCode,
    payload,
    siteScope = null
) {
    if (userId == null || !payload || typeof payload !== 'object') return;
    const key = buildAuditPerformanceFilterStorageKey(
        userId,
        programCode,
        siteScope
    );
    try {
        localStorage.setItem(key, JSON.stringify(payload));
    } catch {
        // Quota or private mode — ignore
    }
}
